import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_INCREMENT_SETTINGS);

const _pk_name = "id";

const state = {
  data: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false,
  editMode: false,
  record:{}
};

const getters = {
  editMode:(state) =>{
    return state.editMode;
  },
  record: (state) => {
    return state.record;
  }
}

const mutations = {
  set: (state, [payload, id]) => {
    if(id){
      state.data[id] = payload;
      state.data = { ... state.data}
    }
  },

  addEntity: (state, [payload, id]) => {
    if(!state.data[id]){  
      state.data[id] = [...payload]
    } else {
      state.data[id] = [...state.data[id],...payload]
    }
  },

  updateEntityById: (state, [payload, id]) => {
    for(let i=0; i < state.data[id].length; i++) {
      if(state.data[id][i][_pk_name] === payload.id) {
        state.data[id].splice(i, 1, payload);
      }
    }
  },

  removeEntityById: (state, [payload, id]) => {
    for (let i=0; i < state.data[id].length; i++){
      if (state.data[id][i][_pk_name] == payload){
        state.data[id].splice(i, 1);
      }
    }
    if(state.data[id].length==0)
      state.data={}
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
  setEditMode: (state, payload) => {
    state.editMode = payload.editMode;
    state.record = payload.record;
  }
}

const actions = {
  async fetchAll({commit}, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
            le_id: payload
          }
      });
      commit("setFetching", false);
      if(res.status == 200) {
        if(res.data.payload.data.length!=0)
         commit("set", [res.data.payload.data, payload]);
      }
      return res;
    }catch(err) {
      throw errorHandler(err.response);
    }
  },

  async create({commit}, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      if(res.status == 200) {
        commit("addEntity", [res.data, payload.le_id]);
      }
      return res;
    }catch(err) {
      throw errorHandler(err.response);
    }
  },

  async update({commit}, [payload, id]) {
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/`, payload);
      commit("setSaving", false);
      if(res.status == 200) {
        commit("updateEntityById", [res.data, id]);
      }
      return res;
    }catch(err) {
      throw errorHandler(err.response);
    }
  },

  async delete({commit}, [payload, id]) {
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEntityById", [payload.id, id]);
      }
    }catch(err) {
      throw errorHandler(err.response);
    }
  },
    async changeEditMode({ commit }, payload) {

      try {
        commit("setEditMode", payload);
      } catch(err) {
        throw errorHandler(err.response);
      }  
    }
}

export default {
  namespaced: true,
  state, mutations, actions,getters
}
